const component = "edit-site-details-form";

export const editSiteDetailsForm = {
  component,
  siteName: {
    label: `${component}/site-name/label`,
    input: `${component}/site-name/input`,
  },
  siteArea: {
    label: `${component}/site-area/label`,
    input: `${component}/site-area/input`,
  },
  peakHourTarif: {
    label: `${component}/peak-hour-tarif/label`,
    input: `${component}/peak-hour-tarif/input`,
  },
  offPeakHourTarif: {
    label: `${component}/off-peak-hour-tarif/label`,
    input: `${component}/off-peak-hour-tarif/input`,
  },
};
